<template>  
  <b-card v-if="isloading">
    <center><b-spinner></b-spinner></center>
  </b-card>
  <b-card v-else>
    <b-card-title>
      <div class="d-flex w-100">
          <b-col sm="12" class="d-flex">
            <div class="w-100">
              <b-row class="ml-1">
              </b-row>
              <b-row class="ml-1">
              </b-row>
            </div>
            <div class="mr-0">
              <h3>{{cow.katalognr}}</h3>
            </div>
          </b-col>
      </div>
    </b-card-title>
      <b-card-text class="mt-2 pt-2 w-100 border-top">
        <b-row class="w-100 m-0">
          <b-col class="pl-0 py-1">OM-Nummer:</b-col>
          <b-col class="pl-0 py-1">CH120676545431</b-col>
          <b-col class="pl-0 py-1"></b-col>
          <b-col class="pl-0 py-1"></b-col>
        </b-row>
        <b-row class="w-100 m-0">
          <b-col class="pl-0 py-1">Produktionsart:</b-col>
          <b-col class="pl-0 py-1">QM</b-col>
          <b-col class="pl-0 py-1">Kontingentsberechtigt:</b-col>
          <b-col class="pl-0 py-1">JA</b-col> 
        </b-row>
        <b-row class="w-100 m-0">
          <b-col class="pl-0 py-1">Nettogewicht:</b-col>
          <b-col class="pl-0 py-1">480kg</b-col>
          <b-col class="pl-0 py-1">Kategorie:</b-col>
          <b-col class="pl-0 py-1">VK</b-col>
        </b-row>
        <b-row class="w-100 m-0">
          <b-col class="pl-0 py-1">Fleischigkeit:</b-col>
          <b-col class="pl-0 py-1">T</b-col>
          <b-col class="pl-0 py-1">Fett:</b-col>
          <b-col class="pl-0 py-1">3</b-col>
        </b-row>
        <b-row class="w-100 m-0">
          <b-col class="pl-0 py-1">Schatzungspreis:</b-col>
          <b-col class="pl-0 py-1">4.20 SFr./kg</b-col>
          <b-col class="pl-0 py-1"></b-col>
          <b-col class="pl-0 py-1"></b-col>
        </b-row>
      </b-card-text>
  </b-card>
</template>

<script>

import Auction from '@/states/auction.js';
export default {
  name: 'Cow-Card',
  data(){
    return {
      cow: {
      },
      isloading: true,
    }
  },
  props: {
    id:{
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async Cow(id){
      try {
        const response = await Auction.cow(id);
        this.cow = response
        this.isloading = false
      } catch(error){
        this.msg = error
        // console.log(this.msg)
      }
    }
  },
  components: {},
  mounted(){
    if (this.isActive){
      this.Cow(this.id)
    }
    window.scrollTo(0, 0)
  },
  computed:{
    isonline(){
      if (!this.online){
        return 'isoffline'
      }
      return ''
    }
  },
  watch: {
    isActive: function (val) {
      if (val){

        // this.$socket.emit('showdata',this.id)
        // this.sockets.subscribe('actualvorgebot', (data) => {
        //   if (data[0]==this.id){
        //     var jsondata = JSON.parse(data[1])
        //     if (jsondata.auktionvalue == 0) {
        //       this.newprice = jsondata.new
        //       this.actprice = jsondata.act
        //       this.saleuser = jsondata.saleuser
        //       this.isOpen = true
        //     } else {
        //       this.isOpen = false
        //     }
        //   }
        // });
        // this.sockets.subscribe('actualprice', (data) => {
        //   var jsondata = JSON.parse(data)
        //   if (jsondata.cow==this.id){
        //     if (jsondata.auktionvalue == 0) {
        //       this.newprice = jsondata.new
        //       this.actprice = jsondata.act
        //       this.saleuser = jsondata.saleuser
        //       this.isOpen = true
        //     } else {
        //       this.isOpen = false
        //     }
        //   }
        // });
        this.Cow(this.id)
      } else {
        // this.sockets.unsubscribe('actualvorgebot')
          this.newprice = 0
          this.actprice = 0
          this.isOpen = false
      }
    }
  }
  
}
</script>

<style style="scss" scoped>
.cardsize  {
  height: 150px;
}
.right-0{
  right: 0%;
}
.bottom-0{
  bottom: 0%;
}

.maxw{
  max-width: 200px !important;
}
.live {
  color: #2020ff;
}
.isoffline {
  background-color: #e0e0e0;
}
</style>
